import React, { useState } from 'react';
import { Form, Button, Accordion } from 'react-bootstrap';
import apiService from "../services/apiService";
import { useNavigate } from "react-router-dom";
import { useToast } from "../hooks/useToast";
import { MESSAGE } from "../constants/constant";

/* ********************************************************
* 01/13/2025 : Erik
* This page was created to allow the user to create a new opportunity.
* it was abandoned when the client expressed the desire to only use ZOHO for opportunity creation.
* http://localhost:3001/createOpportunity
*
******************************************************** */

const CreateOpportunityPage = () => {
  const { addToast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const generateUniqueId = () => {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 1000);
    return `${timestamp}-${random}`;
  };

  const [formData, setFormData] = useState({
    Opportunity_Name: generateUniqueId(), //autogenerate based on timestamp
    Deal_Name: '',
    Market: '',
    Stage: '',
    Account_Name: '',
    Company_Market: '',
    Primary_Street: '',
    Primary_State: '',
    Primary_City: '',
    Primary_Code_Zip: '',
    Customer_Tower_Designation: '',
    Contact_Name: '',
    ATS_Products: '',
    ATS_RTM_Visit_Site: '',
    D_Camera_Used: '',
    Opportunity_Co_Owner: '',
    Customer_Sale_Price: '',
    nd_Sales_Rep_Firm: '',
    nd_Sales_Rep_Person: '',
    Key_Project: '',
    Internal_Meeting: '',
    Competitors1: '',
    Customer_RFQ: '',
    Date_Bid_Due: '',
    Closing_Date: '',
    Scope_of_Work: '',
    Pricing_Type: '',
    Bid_Bond: '',
    Performance_and_Payment_Bond_Required: '',
    Base_Bid: '',
    Fire_Watch: '',
    Full_Time_Safety_Required: '',
    Asbestos_Removal: '',
    Confined_Space_Attendent: '',
    Air_Monitor: '',
    Number_of_Cells_Down_During_Construction: '',
    Labor_By: '',
    Labor_Type: '',
    Prevail_or_Union_Wages_Attached: '',
    Access_Around_Tower: '',
    Decision_Based_On: '',
    Lumber_Type: '',
    Hardware: '',
    Fiberglass_Type: '',
    Freight_By: '',
    Frieght_Detail: '',
    Dumpsters_By: '',
    Electric_Power: '',
    Forklift_By: '',
    Manlift_By: '',
    Haul_Stage: '',
    Unload_By: '',
    Fan_Stack_Fire_Rating: '',
    Sheathing_Fire_Rating: '',
    Crane_By: '',
    Sanitary_Facilities_By: '',
    Subcontractors: '',
    ATS_Shredder: '',
    Outage_or_Not: '',
    Outage_Dates_Firm: '',
    Outage_Calender_Duration_Days: '',
    Working_Hours_in_Day: '',
    Working_Days: '',
    Tower_Available_Start_Date: '',
    Customer_Clean_and_Drain_CWB_If_Outage: '',
    Client_Clean_Cold_Water_Basin: ''
  });

  const requireFields = [
    'Opportunity_Name',
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    for (const field of requireFields) {
      if (!formData[field] || formData[field].trim() === '') {
        console.error(`${field} is required`);
        addToast(`${field.replace(/_/g, ' ')} is required`);
        setIsSubmitting(false);
        return;
      }
    }

    try {
    
      console.log(formData);

      const response = await apiService.post(
        "/opportunity/createNewOpportunity",
        formData
      );

      if (response.status === 201) {
        console.log("Opportunity saved to database:", response.data);
        addToast("Submitted Successfully!");
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error creating Opportunity:", error);
      addToast(MESSAGE.SERVER_ERROR);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="create-project-wrapper">
      <div className="create-project-container">
        <h1>Create New Opportunity</h1>
          <Form onSubmit={handleSubmit}>
            <div></div>
              
              <Form.Group className="mb-3">
                <Form.Label>Opportunity Name</Form.Label>
                <Form.Control
                  type="text"
                  name="Opportunity_Name"
                  value={formData.Opportunity_Name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                <Accordion.Header>Opportunity Information</Accordion.Header>
                <Accordion.Body>
              
                  <Form.Group className="mb-3">
                    <Form.Label>Deal Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="Deal_Name"
                      value={formData.Deal_Name}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Market</Form.Label>
                    <Form.Control
                      type="text"
                      name="Market"
                      value={formData.Market}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Stage</Form.Label>
                    <Form.Select
                      name="Stage"
                      value={formData.Stage}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Pending Proposal Budget">Pending Proposal Budget</option>
                      <option value="Pending Proposal Actual">Pending Proposal Actual</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="Account_Name"
                      value={formData.Account_Name}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Company Market</Form.Label>
                    <Form.Select
                      name="Company_Market"
                      value={formData.Company_Market}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Plant">Plant</option>
                      <option value="Chemical">Chemical</option>
                      <option value="Independent Power Producer">Independent Power Producer</option>
                      <option value="Aftermarket">Aftermarket</option>
                      <option value="GADSBY">GADSBY</option>
                      <option value="Independent Power Producer">Independent Power Producer</option>
                      <option value="Clean Harbors - UT">Clean Harbors - UT</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Primary Street</Form.Label>
                    <Form.Control
                      type="text"
                      name="Primary_Street"
                      value={formData.Primary_Street}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Primary State</Form.Label>
                    <Form.Select
                      name="Primary_State"
                      value={formData.Primary_State}
                      onChange={handleChange}
                    >
                      <option value="">State</option>
                      <option value="AL">AL</option>
                      <option value="AK">AK</option>
                      <option value="AZ">AZ</option>
                      <option value="AK">AK</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="IA">IA</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="ME">ME</option>
                      <option value="MD">MD</option>
                      <option value="MA">MA</option>
                      <option value="MI">MI</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MO">MO</option>
                      <option value="MT">MT</option>
                      <option value="NE">NE</option>
                      <option value="NV">NV</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NY">NY</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VT">VT</option>
                      <option value="VA">VA</option>
                      <option value="WA">WA</option>
                      <option value="WV">WV</option>
                      <option value="WI">WI</option>
                      <option value="WY">WY</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Primary City</Form.Label>
                    <Form.Control
                      type="text"
                      name="Primary_City"
                      value={formData.Primary_City}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Primary Zip Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="Primary_Code_Zip"
                      value={formData.Primary_Code_Zip}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Customer Tower Designation</Form.Label>
                    <Form.Control
                      type="text"
                      name="Customer_Tower_Designation"
                      value={formData.Customer_Tower_Designation}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Contact Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="Contact_Name"
                      value={formData.Contact_Name}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>ATS Products</Form.Label>
                    <Form.Control
                      type="text"
                      name="ATS_Products"
                      value={formData.ATS_Products}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Tech MGR Visited Site (Not Sales Rep)</Form.Label>
                    <Form.Select
                      name="ATS_RTM_Visit_Site"
                      value={formData.ATS_RTM_Visit_Site}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>3D Camera Used?</Form.Label>
                    <Form.Select
                      name="D_Camera_Used"
                      value={formData.D_Camera_Used}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Opportunity Owner</Form.Label>
                    <Form.Control
                      type="text"
                      name="Opportunity_Co_Owner"
                      value={formData.Opportunity_Co_Owner}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Customer Sale Price</Form.Label>
                    <Form.Control
                      type="text"
                      name="Customer_Sale_Price"
                      value={formData.Customer_Sale_Price}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Sales Rep Firm</Form.Label>
                    <Form.Control
                      type="text"
                      name="nd_Sales_Rep_Firm"
                      value={formData.nd_Sales_Rep_Firm}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Sales Rep Person:</Form.Label>
                    <Form.Control
                      type="text"
                      name="nd_Sales_Rep_Person"
                      value={formData.nd_Sales_Rep_Person}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Key Project:</Form.Label>
                    <Form.Select
                      name="Key_Project"
                      value={formData.Key_Project}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Internal Meeting to Review:</Form.Label>
                    <Form.Select
                      name="Internal_Meeting"
                      value={formData.Internal_Meeting}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      <option value="Need To Complete">Need To Complete</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Competitors:</Form.Label>
                    <Form.Select
                      name="Competitors1"
                      value={formData.Competitors1}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Unknown">Unknown</option>
                      <option value="American Cooling Tower">American Cooling Tower</option>
                      <option value="Cooling Tower Depot">Cooling Tower Depot</option>
                      <option value="ICT">ICT</option>
                      <option value="Midwest Cooling Tower">Midwest Cooling Tower</option>
                      <option value="Cajun Cooling">Cajun Cooling</option>
                      <option value="EvapTech">EvapTech</option>
                      <option value="SPX">SPX</option>
                      <option value="OBR">OBR</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Formal RFQ:</Form.Label>
                    <Form.Select
                      name="Customer_RFQ"
                      value={formData.Customer_RFQ}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Date Bid Due:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Date_Bid_Due"
                      value={formData.Date_Bid_Due}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Closing Date:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Closing_Date"
                      value={formData.Closing_Date}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Scope of Work Rec'd:</Form.Label>
                    <Form.Select
                      name="Scope_of_Work"
                      value={formData.Scope_of_Work}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Commercial Info</Accordion.Header>
                <Accordion.Body>

                  <Form.Group className="mb-3">
                    <Form.Label>Pricing Type:</Form.Label>
                    <Form.Select
                      name="Pricing_Type"
                      value={formData.Pricing_Type}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Lump Sum">Lump Sum</option>
                      <option value="Time and Material">Time and Material</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Bid Bond:</Form.Label>
                    <Form.Select
                      name="Bid_Bond"
                      value={formData.Bid_Bond}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="N/A">N/A</option>
                      <option value="5% of contract Value">5% of contract Value</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Performance and Payment Bond Required:</Form.Label>
                    <Form.Select
                      name="Performance_and_Payment_Bond_Required"
                      value={formData.Performance_and_Payment_Bond_Required}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Scope of Work</Accordion.Header>
                <Accordion.Body>

                  <Form.Group className="mb-3">
                    <Form.Label>Base Bid:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Base_Bid"
                      value={formData.Base_Bid}
                      onChange={handleChange}
                    />
                  </Form.Group>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Safety</Accordion.Header>
                <Accordion.Body>

                  <Form.Group className="mb-3">
                    <Form.Label>Fire Watch:</Form.Label>
                    <Form.Select
                      name="Fire_Watch"
                      value={formData.Fire_Watch}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Required">Required</option>
                      <option value="Not Required">Not Required</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Full Time Safety Required:</Form.Label>
                    <Form.Select
                      name="Full_Time_Safety_Required"
                      value={formData.Full_Time_Safety_Required}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Asbestos Removal:</Form.Label>
                    <Form.Select
                      name="Asbestos_Removal"
                      value={formData.Asbestos_Removal}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Required">Required</option>
                      <option value="Not Required">Not Required</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Confined Space Attendent:</Form.Label>
                    <Form.Select
                      name="Confined_Space_Attendent"
                      value={formData.Confined_Space_Attendent}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes- 1 Required">Yes- 1 Required</option>
                      <option value="Yes- 2 Required">Yes- 2 Required</option>
                      <option value="Yes- 3 Required">Yes- 3 Required</option>
                      <option value="Not Required">Not Required</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Multi-Gas Detection Monitor:</Form.Label>
                    <Form.Select
                      name="Air_Monitor"
                      value={formData.Air_Monitor}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Required">Required</option>
                      <option value="Not Required">Not Required</option>
                    </Form.Select>
                  </Form.Group>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Construction & Materials</Accordion.Header>
                <Accordion.Body>

                  <Form.Group className="mb-3">
                    <Form.Label>Number of Cells Down During Construction:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Number_of_Cells_Down_During_Construction"
                      value={formData.Number_of_Cells_Down_During_Construction}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Labor By:</Form.Label>
                    <Form.Select
                      name="Labor_By"
                      value={formData.Labor_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="ATS Direct">ATS Direct</option>
                      <option value="ATS Subcontractor">ATS Subcontractor</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Labor Type:</Form.Label>
                    <Form.Select
                      name="Labor_Type"
                      value={formData.Labor_Type}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Union">Union</option>
                      <option value="Non-Union">Non-Union</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Prevail or Union, Wages Attached:</Form.Label>
                    <Form.Select
                      name="Prevail_or_Union_Wages_Attached"
                      value={formData.Prevail_or_Union_Wages_Attached}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Access Around SIDES Tower:</Form.Label>
                    <Form.Select
                      name="Access_Around_Tower"
                      value={formData.Access_Around_Tower}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes, one side">Yes, one side</option>
                      <option value="Yes, two sides">Yes, two sides</option>
                      <option value="See 360 Photos">See 360 Photos</option>
                      <option value="No, supply photo or sketch">No, supply photo or sketch</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Access Around ENDS Tower:</Form.Label>
                    <Form.Select
                      name="Decision_Based_On"
                      value={formData.Decision_Based_On}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes, one side">Yes, one end</option>
                      <option value="Yes, two sides">Yes, two end</option>
                      <option value="See 360 Photos">See 360 Photos</option>
                      <option value="No, supply photo or sketch">No, supply photo or sketch</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Lumber Type:</Form.Label>
                    <Form.Select
                      name="Lumber_Type"
                      value={formData.Lumber_Type}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="Douglas Fir CCA">Douglas Fir CCA</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Hardware:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Hardware"
                      value={formData.Hardware}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Fiberglass Type:</Form.Label>
                    <Form.Select
                      name="Fiberglass_Type"
                      value={formData.Fiberglass_Type}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="Polyester">Polyester</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Freight By:</Form.Label>
                    <Form.Select
                      name="Freight_By"
                      value={formData.Freight_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Freight Detail:</Form.Label>
                    <Form.Select
                      name="Frieght_Detail"
                      value={formData.Frieght_Detail}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="Prepay and Add +7%">Prepay and Add +7%</option>
                      <option value="FOB Jobsite">FOB Jobsite</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Dumpsters By:</Form.Label>
                    <Form.Select
                      name="Dumpsters_By"
                      value={formData.Dumpsters_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS (Off Site Landfill)">ATS (Off Site Landfill)</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Electric Power:</Form.Label>
                    <Form.Select
                      name="Electric_Power"
                      value={formData.Electric_Power}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS Generators">ATS Generators</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Forklift By:</Form.Label>
                    <Form.Select
                      name="Forklift_By"
                      value={formData.Forklift_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Manlift By:</Form.Label>
                    <Form.Select
                      name="Manlift_By"
                      value={formData.Manlift_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Haul Stage:</Form.Label>
                    <Form.Select
                      name="Haul_Stage"
                      value={formData.Haul_Stage}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Unload By:</Form.Label>
                    <Form.Select
                      name="Unload_By"
                      value={formData.Unload_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Fan Stack Fire Rating:</Form.Label>
                    <Form.Select
                      name="Fan_Stack_Fire_Rating"
                      value={formData.Fan_Stack_Fire_Rating}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="NA">NA</option>
                      <option value="GP">GP</option>
                      <option value="FR">FR</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Sheathing Fire Rating</Form.Label>
                    <Form.Select
                      name="Sheathing_Fire_Rating"
                      value={formData.Sheathing_Fire_Rating}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="NA">NA</option>
                      <option value="GP">GP</option>
                      <option value="FR">FR</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Crane By:</Form.Label>
                    <Form.Select
                      name="Crane_By"
                      value={formData.Crane_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Sanitary and Wash Station Facilities By:</Form.Label>
                    <Form.Select
                      name="Sanitary_Facilities_By"
                      value={formData.Sanitary_Facilities_By}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="ATS">ATS</option>
                      <option value="Owner">Owner</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Subcontractors:</Form.Label>
                    <Form.Select
                      name="Subcontractors"
                      value={formData.Subcontractors}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Not Required">Not Required</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>ATS Shredder:</Form.Label>
                    <Form.Select
                      name="ATS_Shredder"
                      value={formData.ATS_Shredder}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>Key Project Dates</Accordion.Header>
                <Accordion.Body>

                  <Form.Group className="mb-3">
                    <Form.Label>Outage or Not:</Form.Label>
                    <Form.Select
                      name="Outage_or_Not"
                      value={formData.Outage_or_Not}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Outage Dates Firm:</Form.Label>
                    <Form.Select
                      name="Outage_Dates_Firm"
                      value={formData.Outage_Dates_Firm}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Outage Calendar Duration Days:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Outage_Calender_Duration_Days"
                      value={formData.Outage_Calender_Duration_Days}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Working Hours in Day:</Form.Label>
                    <Form.Select
                      name="Working_Hours_in_Day"
                      value={formData.Working_Hours_in_Day}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1 Hour Day">1 Hour Day</option>
                      <option value="2 Hour Day">2 Hour Day</option>
                      <option value="3 Hour Day">3 Hour Day</option>
                      <option value="4 Hour Day">4 Hour Day</option>
                      <option value="5 Hour Day">5 Hour Day</option>
                      <option value="6 Hour Day">6 Hour Day</option>
                      <option value="7 Hour Day">7 Hour Day</option>
                      <option value="8 Hour Day">8 Hour Day</option>
                      <option value="9 Hour Day">9 Hour Day</option>
                      <option value="10 Hour Day">10 Hour Day</option>
                      <option value="11 Hour Day">11 Hour Day</option>
                      <option value="12 Hour Day">12 Hour Day</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Working Days:</Form.Label>
                    <Form.Select
                      name="Working_Days"
                      value={formData.Working_Days}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Tower Available Start Date:</Form.Label>
                    <Form.Control
                      type="text"
                      name="Tower_Available_Start_Date"
                      value={formData.Tower_Available_Start_Date}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Customer Clean and Drain CWB:</Form.Label>
                    <Form.Select
                      name="Customer_Clean_and_Drain_CWB_If_Outage"
                      value={formData.Customer_Clean_and_Drain_CWB_If_Outage}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Client Clean Cold Water Basin:</Form.Label>
                    <Form.Select
                      name="Client_Clean_Cold_Water_Basin"
                      value={formData.Client_Clean_Cold_Water_Basin}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="mt-4 d-flex justify-content-end">
              <Button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save Opportunity"}
              </Button>
            </div>

          </Form>
        </div>
      </div>
  );
};

export default CreateOpportunityPage;